import { MessageOperation, RequestOperation } from '@peercolab/engine'
import { SearchInput, Thumbnail, FileUploadUploadInfo } from '../../Core/PathItems'
import { UpdateTrainerSignatureInput } from '../../PathItems'
import { Published } from '../Core/PathItems'

export class CreateTrainer extends RequestOperation<CreateTrainerInput,Trainer> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.CreateTrainer",
      "CREATE",
      ["TrainerId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class SearchTrainer extends RequestOperation<SearchInput,Trainer[]> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.SearchTrainer",
      "SEARCH",
      ["TrainerId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class DeleteTrainer extends MessageOperation<object> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.DeleteTrainer",
      "DELETE",
      ["TrainerId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateTrainerName extends MessageOperation<UpdateTrainerNameInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.UpdateTrainerName",
      "PATCH",
      ["TrainerId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateTrainerDescription extends MessageOperation<UpdateTrainerDescriptionInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.UpdateTrainerDescription",
      "PATCH",
      ["TrainerId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateTrainerExperienceInYears extends MessageOperation<UpdateTrainerExperienceInYearsInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.UpdateTrainerExperienceInYears",
      "PATCH",
      ["TrainerId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateTrainerThumbnail extends MessageOperation<UpdateTrainerThumbnailInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.UpdateTrainerThumbnail",
      "PATCH",
      ["TrainerId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class GetTrainer extends RequestOperation<object,Trainer> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.GetTrainer",
      "GET",
      ["TrainerId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateTrainerState extends MessageOperation<UpdateTrainerStateInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.UpdateTrainerState",
      "PATCH",
      ["TrainerId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateTrainerSignature extends MessageOperation<UpdateTrainerSignatureInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Trainers.UpdateTrainerSignature",
      "PATCH",
      ["TrainerId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export type CreateTrainerInput = {
  trainerId?: string | undefined
  name: string
  description?: string | undefined
  experienceInYears?: number | undefined
}

export type Trainer = {
  id: string
  name: string
  description: string
  experienceInYears: number
  thumbnail?: Thumbnail | undefined
  signature?: Thumbnail | undefined
  state: Published
}

export type UpdateTrainerNameInput = {
  name: string
}

export type UpdateTrainerDescriptionInput = {
  description: string
}

export type UpdateTrainerExperienceInYearsInput = {
  experienceInYears: number
}

export type UpdateTrainerThumbnailInput = {
  image?: FileUploadUploadInfo | undefined
}

export type UpdateTrainerStateInput = {
  /**
   * Valid values: publish, unpublish, revert
   */
  stateTransition: string
}

